import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, AutoComplete } from 'antd';
import { injectIntl } from 'react-intl';

import { searchArticle } from '../../actions';

class SearchBar extends Component {
  handleSearch = text => {
    this.props.searchArticle({ text });
  }

  renderOption = item => (
    <AutoComplete.Option key={item._id} text={item._id}>
      <a href={`/bai-viet/${item.slug}-${item._id}`}>
        <p>{item.title}</p>
      </a>
    </AutoComplete.Option>
  )

  render() {
    const { intl, search } = this.props;

    return (
      <AutoComplete
        className="global-search"
        style={{ width: '100%' }}
        dataSource={search.articles.map(this.renderOption)}
        onSelect={this.handleSelect}
        onSearch={this.handleSearch}
        placeholder={intl.formatMessage({ id: 'MenuBar.Search' })}
        optionLabelProp="text"
      >
        <Input.Search />
      </AutoComplete>
    );
  }
}

export default injectIntl(connect(state => ({
  search: state.search,
}), {
  searchArticle,
})(SearchBar));



// WEBPACK FOOTER //
// ./src/components/elements/SearchBar.js